/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpgradeSubscriptionRequest = {
  /**
   * The unique identifier of the subscription
   */
  id: string;
  /**
   * Subscription upgrade payload
   */
  upgradeSubscriptionRequestEntity: components.UpgradeSubscriptionRequestEntity;
};

/** @internal */
export const UpgradeSubscriptionRequest$inboundSchema: z.ZodType<
  UpgradeSubscriptionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  UpgradeSubscriptionRequestEntity:
    components.UpgradeSubscriptionRequestEntity$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "UpgradeSubscriptionRequestEntity": "upgradeSubscriptionRequestEntity",
  });
});
/** @internal */
export type UpgradeSubscriptionRequest$Outbound = {
  id: string;
  UpgradeSubscriptionRequestEntity:
    components.UpgradeSubscriptionRequestEntity$Outbound;
};

/** @internal */
export const UpgradeSubscriptionRequest$outboundSchema: z.ZodType<
  UpgradeSubscriptionRequest$Outbound,
  z.ZodTypeDef,
  UpgradeSubscriptionRequest
> = z.object({
  id: z.string(),
  upgradeSubscriptionRequestEntity:
    components.UpgradeSubscriptionRequestEntity$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    upgradeSubscriptionRequestEntity: "UpgradeSubscriptionRequestEntity",
  });
});

export function upgradeSubscriptionRequestToJSON(
  upgradeSubscriptionRequest: UpgradeSubscriptionRequest,
): string {
  return JSON.stringify(
    UpgradeSubscriptionRequest$outboundSchema.parse(upgradeSubscriptionRequest),
  );
}
export function upgradeSubscriptionRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpgradeSubscriptionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpgradeSubscriptionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpgradeSubscriptionRequest' from JSON`,
  );
}
